import { getAppVariable } from '@white-label-helper/get-app-variable';
import { PARTNER_TYPES_CODES } from '@white-label-configuration/constants';
/**
 * Returns true or false depending if the partner type is booking portal
 */
export const isBookingPortal = (): boolean => {
  return getAppVariable('partner_type_code') === PARTNER_TYPES_CODES.BOOKING_PORTAL;
};
